export const sortSearchPaginateGetters = {
  currentPage: state => state.currentPage,
  totalPages: state => state.totalPages,
  hasNext: state => state.hasNext,
  hasPrev: state => state.hasPrev,
  sorting: state => state.sorting,
  searchString: state => state.searchString
};

export const paginationFilterSortGetters = {
  pagination: state => state.pagination,
  sort: state => state.sort,
  search: state => state.search,
  filters: state => state.filters
}
